var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 5.64991C2.25 5.23569 2.58579 4.89991 3 4.89991H21C21.4142 4.89991 21.75 5.23569 21.75 5.64991V18.3999C21.75 18.7977 21.592 19.1793 21.3107 19.4606C21.0294 19.7419 20.6478 19.8999 20.25 19.8999H3.75C3.35218 19.8999 2.97065 19.7419 2.68934 19.4606C2.40804 19.1793 2.25 18.7977 2.25 18.3999V5.64991ZM3.75 6.39991V18.3999H20.25V6.39991H3.75Z",
    fill: "#0078B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.44714 5.14311C2.72703 4.83777 3.20146 4.81715 3.5068 5.09704L12 12.8825L20.4932 5.09704C20.7985 4.81715 21.273 4.83777 21.5529 5.14311C21.8328 5.44845 21.8121 5.92288 21.5068 6.20277L12.5068 14.4528C12.2201 14.7156 11.78 14.7156 11.4932 14.4528L2.49321 6.20277C2.18787 5.92288 2.16724 5.44845 2.44714 5.14311Z",
    fill: "#0078B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.f578a5aab05eacf5ccf14d0a318ce0ad.svg";
export { ForwardRef as ReactComponent };